import { render } from "./2fa.vue?vue&type=template&id=40b90a94&scoped=true"
import script from "./2fa.vue?vue&type=script&lang=js"
export * from "./2fa.vue?vue&type=script&lang=js"

import "./2fa.vue?vue&type=style&index=0&id=40b90a94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b90a94"]])

export default __exports__